module.exports = __webpack_public_path__ + "static/media/th-list.6d22b5f2.svg";